import PrePlanning from "./pre_planning.coffee"

$(document).on 'turbolinks:load', ->
  PrePlanning.add_listeners()
  PrePlanning.handle_on_update_total_calculation()
  PrePlanning.handler_events()
